import React from "react";
import { initializeAnalytics } from "@lululemon/mwa-analytics";
import { composeDataMethods } from "@lululemon/mwa-utils";
const withAnalytics = Component => {
  const WithAnalytics = props => {
    if (typeof window !== "undefined") {
      const plugins = Object.values([...(window.analyticsPlugins || []), ...((props === null || props === void 0 ? void 0 : props.analyticsPlugins) || [])].reduce((result, currentPlugin) => {
        if (!result[currentPlugin.name]) {
          result[currentPlugin.name] = currentPlugin;
        }
        return result;
      }, {}));
      initializeAnalytics("MWA_COMMON", {}, plugins);
    }
    return /*#__PURE__*/React.createElement(Component, props);
  };
  return composeDataMethods(Component, {})(WithAnalytics);
};
export default withAnalytics;